// extracted by mini-css-extract-plugin
export var attachment = "_o9-a";
export var emailContainer = "_o9-4";
export var emailContentPaddedContainer = "_o9-b";
export var emailHeader = "_o9-6";
export var emailIframe = "_o9-3";
export var emailInfoIcon = "_o9-9";
export var emailShortenedSummary = "_o9-e";
export var infoDropdown = "_o9-0";
export var infoRowBoundedContent = "_o9-d";
export var internal = "_o9-5";
export var merchant = "_o9-8";
export var messageInputContainer = "_o9-h";
export var normal = "_o9-7";
export var replyCard = "_o9-f";
export var subtleButton = "_o9-1";
export var subtleButtonIconContainer = "_o9-2";
export var toggleViewRepliesButton = "_o9-c";
export var wrappingText = "_o9-g";